/* import __COLOCATED_TEMPLATE__ from './draggable-icon.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    showDraggableIcon: boolean;
  };
}

const DraggableIcon = templateOnlyComponent<Signature>();
export default DraggableIcon;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::DraggableIcon': typeof DraggableIcon;
    'knowledge-hub/filterable-list/table/cells/draggable-icon': typeof DraggableIcon;
  }
}
